export function MetricTile({
  label,
  value,
  detail,
  gain,
  tone = "default",
}: {
  label: string;
  value: string | number;
  detail: string;
  gain?: string;
  tone?: "default" | "success";
}) {
  return (
    <div className="rounded-lg border border-border p-3">
      <p className="text-[10.5px] font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </p>
      <p
        className={`mt-1 text-[18px] font-bold ${
          tone === "success" ? "text-success-text" : "text-body"
        }`}
      >
        {value}
      </p>
      <p className="text-[10px] text-muted-foreground">{detail}</p>
      {gain && (
        <p
          className={`mt-1 text-[13px] font-semibold ${
            tone === "success" ? "text-success-text" : "text-brand-gold-dark"
          }`}
        >
          {gain} <span className="text-[10px] font-normal text-muted-foreground">gain</span>
        </p>
      )}
    </div>
  );
}
